import React from "react";
import Questions from '../data/questions';
import QuizItem from './QuizItem';
class Quiz extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      questions: Questions
    };
  }

  render () {
    return (
      <div className='well well-lg'>
        <div className='row bottom-border'>
          <div className='col-md-8'>
            <p className='title'>What Church is The Church?</p>
          </div>
          <div className='col-md-4'>
            <img src={this.props.titleImageSrc} />
          </div>
        </div>
        <div className='row' id='questions'>
          <div className='col-md-12'>
            {this.state.questions.map((q) => (
              <QuizItem key={q.number} number={q.number} question={q.question} answers={q.answers} annotation={q.annotation} isTextAnswer={q.isTextAnswer} />
            ))}
          </div>
        </div>
      </div>
    );
  }
}
export default Quiz;
